// Type getSalesOrderDocuments gives the document a purchase order was extracted from.
export const PURCHASE_ORDER_SOURCE_DOCUMENT_TYPE = 'PURCHASE_ORDER_SOURCE_DOCUMENT';
